/** Client stubs — original Lovable server functions are not used in this SPA. */

type AdminInsightsInput = {
  range: string;
  total: number;
  pending: number;
  assigned: number;
  reward: number;
  notProper: number;
  teachers: number;
  rewardRate: number;
  verificationRate: number;
  topTeachers: Array<{ name: string; verified: number }>;
};

type TeacherFeedbackInput = {
  studentName: string;
  videoTitle: string;
  decision: "Ready for Reward" | "Not Proper";
  notes: string;
};

export async function generateAdminInsights(
  _data: AdminInsightsInput
): Promise<{ text: string }> {
  return {
    text: "AI insights are not configured in this build. Connect your AI gateway to enable executive summaries.",
  };
}

export async function generateTeacherFeedback(
  data: TeacherFeedbackInput
): Promise<{ text: string }> {
  return {
    text: `Thank you, ${data.studentName}, for submitting “${data.videoTitle}”. Status: ${data.decision}.${data.notes ? ` Notes: ${data.notes}` : ""}`,
  };
}
